import React, { useEffect, useState } from "react";
import FooterContentsComponent from "./FooterContentsComponent";
import CopyRighSectionComponent from "./CopyRighSectionComponent";
import { useSelector } from "react-redux";
import "./footer.css";
import FooterContentsComponentCopy from "./FooterContentsComponent copy";

const FooterComponent = () => {
  const data = useSelector((state) => state.companyDetails);
  const [companyDetails, setCompanyDetails] = useState(data);

  useEffect(() => {
    if (data?.status) {
      setCompanyDetails(data.response);
    }
  }, [data, companyDetails]);
  return (
    <>
      <div className="footer-section">
        {/* <FooterContentsComponent /> */}
        <FooterContentsComponentCopy />
        <CopyRighSectionComponent />
      </div>
    </>
  );
};

export default FooterComponent;
